<script lang="ts">
    import {isNull} from '../../../../shared/utils/custom-utils';
    import type {EditorsLocalizationFunction} from '../../localizations/types';
    import type {SingleAcceptableValueEditorLocalizations} from './types';
    import {getContext} from 'svelte';
    import {EDITORS_LOCALIZE} from '../../context-keys';

    export let optionIdentifier: string | number | null;

    const localize: EditorsLocalizationFunction<SingleAcceptableValueEditorLocalizations> = getContext(EDITORS_LOCALIZE);
</script>
<template>
    {#if isNull(optionIdentifier)}
        {localize('noneOfTheOptions')}
    {:else}
        <slot {optionIdentifier}></slot>
    {/if}
</template>